import { z } from 'zod';

/**
 * Phase ① CaseBriefAgent — output.
 *
 * Format : markdown texte auto-portant (~10-30k tokens). Pas de JSON à parser.
 * Les sections H1 obligatoires (`# Parties`, `# Faits chronologiques`,
 * `# Procédure`, `# Prétentions`) sont **incitées dans le prompt** mais
 * pas validées strictement à l'arrivée — on logue les briefs incomplets et
 * on itère sur le prompt plutôt que de casser la pipeline.
 *
 * Voir hub doc § 4 ① (`docs/architecture/plan-detaille-v2.md`).
 */
export const CaseBriefOutputSchema = z.string();
export type CaseBriefOutput = z.infer<typeof CaseBriefOutputSchema>;
